import React from 'react'
import { useTranslation } from 'react-i18next'

import { ItemOrder } from '@makyoapp/makyo-common'
import { CaretDown, CaretUp } from '@makyoapp/makyo-icon/icon'
import { Th, Tr } from '@makyoapp/makyo-ui'

interface TheadProps<T extends string> {
  fields: T[]
  withAction?: boolean
}

export function Thead<T extends string>({ fields, withAction }: TheadProps<T>) {
  const { t } = useTranslation()

  return (
    <thead>
      <Tr>
        {fields.map((f) => {
          return (
            <th
              style={{
                width: '18%',
              }}
              className={f}
              key={f}
            >
              {t(f === 'addedOn' ? 'Date Added' : f)}
            </th>
          )
        })}
        {withAction === true && <Th className='act' />}
      </Tr>
    </thead>
  )
}

interface TheadWithSortProps<T extends string> {
  fields: T[]
  sort?: ItemOrder
  setSort: (nextSort: ItemOrder) => void
  sortBy?: T
  setSortBy: (nextSortBy: T) => void
}

export function TheadWithSort<T extends string>({ fields, sort, setSort, sortBy, setSortBy }: TheadWithSortProps<T>) {
  const { t } = useTranslation()

  return (
    <thead>
      <Tr>
        {fields.map((f) => {
          const nextOrder = sortBy === f ? (sort === 'asc' ? 'desc' : 'asc') : 'asc'
          const currentOrder = sortBy === f ? sort : 'desc'

          return (
            <Th className={f} key={f}>
              <button
                className='uppercase flex-c'
                onClick={() => {
                  setSortBy(f)
                  setSort(nextOrder)
                }}
              >
                <span>{t(f)}</span>
                {currentOrder === 'asc' ? <CaretUp /> : <CaretDown />}
              </button>
            </Th>
          )
        })}
      </Tr>
    </thead>
  )
}
